<template>
	<div>
		<section class="container">
			<div class="row">
				<div class="col-xs-12">
					<h1>Hello {{ user.first_name }}</h1>
					<div class="page-summary-container">
						<div class="page-summary-text">
							You last logged in: {{ loggedInDate }} at {{ loggedInTime }}
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12">
					<h2>What would you like to do?</h2>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
					<router-link to="/admin/regulations">
						<div class="nav-card-container">
							<div class="nav-card-title">
								Regulations
							</div>
							<div class="nav-card-summary">
								Add, edit & delete regulations
							</div>
						</div>
					</router-link>
				</div>
				<div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
					<router-link to="/admin/tags-regions">
						<div class="nav-card-container">
							<div class="nav-card-title">
								Manage tags
							</div>
							<div class="nav-card-summary">
								Countries & Regions, Issues types and Status tags.
							</div>
						</div>
					</router-link>
					<div class="clearfix visible-sm"/>
				</div>
				<div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
					<router-link to="/admin/pages">
						<div class="nav-card-container">
							<div class="nav-card-title">
								Update pages
							</div>
							<div class="nav-card-summary">
								Edit page contents for Disclaimer & privacy policy
							</div>
						</div>
					</router-link>
					<div class="clearfix visible-sm"/>
				</div>
				<div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
					<router-link to="/admin/downloads">
						<div class="nav-card-container">
							<div class="nav-card-title">
								View downloads
							</div>
							<div class="nav-card-summary">
								View files that users have downloaded
							</div>
						</div>
					</router-link>
					<div class="clearfix visible-sm"/>
				</div>
				<div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
					<router-link to="/admin/users">
						<div class="nav-card-container">
							<div class="nav-card-title">
								Manage users
							</div>
							<div class="nav-card-summary">
								Add, edit & delete users
							</div>
						</div>
					</router-link>
					<div class="clearfix visible-sm"/>
				</div>
			</div>
		</section>
	</div>
</template>

<style lang="less" scoped>
	.container {
		margin-top: 0px;
		padding-bottom: 100px;
	}
</style>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
	computed: {
		...mapGetters({ user: 'user', loginDetails: 'logged_in' }),
		loggedInDate() {
			return moment.unix(this.loginDetails).format('DD MMMM YYYY');
		},
		loggedInTime() {
			return moment.unix(this.loginDetails).format('HH:mm');
		}
	},
};
</script>
